import AirlinePaginatedDropdown from "components/dropdowns/paginated/AirlinePaginatedDropdown";
import { useValidateIsNotNull } from "formvalidation/hooks";
import React from "react";

interface Props {
  value: server.dto.Airline
  validatorKey: string
  focusOnMount?: boolean
  isClearable?: boolean
  onChange: (airline: server.dto.Airline) => void
}

export const AirlineDropdownInput = (props: Props) => {
  const validation = useValidateIsNotNull({
    key: props.validatorKey,
    title: RESX.Flight.Airline,
    value: props.value,
  });

  return <AirlinePaginatedDropdown
    displayFriendyCodeInSelectedValue={false}
    value={props.value}
    onChange={(airline: server.dto.Airline) => {
      props.onChange(airline);
    }}
    config={{
      isSearchable: true,
      isClearable: props.isClearable ?? false,
      hasError: validation.error.hasError,
      focusOnMount: props.focusOnMount,
    }}
  />;
}